<template>
    <div>
        <!-- <b-alert :show="!!errorHandlingMessage" dismissible>{{ errorHandlingMessage }}</b-alert> -->
        <core-error-alerts :errors="errorMsgList"></core-error-alerts>

        <transition name="fade-fast" mode="out-in">
        
            <busy-spinner v-if="loading" key="loadingTrue" inner-class="my-4" text="Loading..."></busy-spinner>

            <div v-else key="loadingFalse">
                
                <!-- <p class="text-muted font-size-80">Submitted by <span class="text-dark font-weight-500">{{ replyData.submitted_by_name }}</span> on {{ formatDateTime(replyData.submitted_on) }}</p> -->
        
                <b-table
                    v-if="allBidLines.length"
                    key="hasBidLines"
                    :items="allBidLines"
                    :fields="tableFields"
                    small
                    hover
                    :tbody-tr-class="tbodyTrClass"
                    class="quotesheet-reply-data-table no-top-border td-align-middle small"
                >
                    <template #cell(item_details)="data">
                        <div v-if="data.item.isFirstVariant">
                            <div class="font-weight-bold">{{ data.item.name }}</div>  <!-- now includes part number -->
                            <div class="font-size-70 text-muted">{{ data.item.description }}</div>
                            <!-- <div class="font-size-70 text-muted">{{ data.item.part_number }}</div> -->
                        </div>
                    </template>
                    <!-- <template #cell(variant_description)="data">
                        <div class="">{{ data.item.variant.description }}</div>
                    </template> -->
                    <template #cell(quantity_details)="data">
                        {{ data.item.quantity }} <span class="text-muted">{{data.item.uom}} {{data.item.timeframe}}</span>
                    </template>
                    <template #cell(price)="data">
                        <div v-if="data.item.nobid" key="nobid" class="text-muted">NO BID</div>
                        <div v-else key="hasBid">{{ data.value }}</div>
                    </template>

                </b-table>

                <!-- <pre>{{ allBidLines }}</pre> -->

            </div>

        </transition>

    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';
//import cloneDeep from 'lodash/cloneDeep';
import pick from 'lodash/pick';
import { 
    //FormatCurrencyHelper, 
    toNumberOrNull,
    hasValueOrZero,
} from '../../js/filters-helpers';
import { vendorColsAll, genericBidPriceFormatter } from './quote-sheet-vendor-cols';
import cloneDeep from 'lodash/cloneDeep';


class QuoteSheetReplyBidLine {
    constructor({ id, reply_id, reply, item, variant, variantIndex, bid }) {
        this.id = id;
        this.reply_id = reply_id;
        this.reply = reply;
        this.item = item;
        this.variant = variant;
        this.isFirstVariant = (variantIndex === 0);  // this is the first variant in the item
        this.bid = bid;
    }
    // GETTERS
    get name() {
        return this.item.linked_product?.name || this.item.linked_product?.display_name || this.item.name; 
        // OLD - changed to match supplier preview version 
        // return this.item.name || this.item.linked_product.name;
    }
    get part_number() {
        return this.item.linked_product?.part_number || this.item.part_number;
    }
    get description() {
        return this.item.description || this.item.linked_product?.description;
    }
    get variant_description() {
        return this.variant.description;
    }
    get quantity() {
        return toNumberOrNull(this.variant.quantity); 
    }
    get uom() {
        return this.variant.uom;
    }
    get timeframe() {
        return this.variant.quantity_timeframe;
    }
    get need_by_date() {
        // TODO - format with Luxon?
        return this.variant.need_by_date;
    }
    // WORKING WITH PRICES
    // to make sure we have numbers, use toNumberOrNull on the amount -- will turn strings into numbers, and return null if not valid or empty
    // do NOT need our full parser used in capturing inputs... since that truncates/rounds things... here, we want to display the values as captured, unchanged
    // so use toNumberOrNull() then use your generic price formatter to actually format the value for display
    get current_price() {
        if (!this.variant.current_price || !this.variant.current_price_currency) return null;
        // OLD return FormatCurrencyHelper(toNumberOrNull(this.variant.current_price), this.variant.current_price_currency);
        return genericBidPriceFormatter(toNumberOrNull(this.variant.current_price), this.variant.current_price_currency);
    }
    get target_price() {
        if (!this.variant.target_price || !this.variant.target_price_currency) return null;
        // OLD return FormatCurrencyHelper(toNumberOrNull(this.variant.target_price), this.variant.target_price_currency);
        return genericBidPriceFormatter(toNumberOrNull(this.variant.target_price), this.variant.target_price_currency);
    }
    get price() {
        if (!this.bid.price || !this.bid.price_currency) return null;
        // OLD return FormatCurrencyHelper(toNumberOrNull(this.bid.price), this.bid.price_currency);
        return genericBidPriceFormatter(toNumberOrNull(this.bid.price), this.bid.price_currency);
    }
    get subtotal() {
        if (!this.bid.price || !this.bid.price_currency) return null;
        const qty = this.quantity ?? 1;
        const price = toNumberOrNull(this.bid.price);
        // should we only do this if subtotal is enabled?  or just not call this if not enabled?
        const subtotalAmount = hasValueOrZero(price) ? price * qty : 0;
        return genericBidPriceFormatter(subtotalAmount, this.bid.price_currency);
    }
    get quoted_price() {
        if (!this.bid.quoted_price || !this.bid.quoted_price_currency) return null;
        // OLD return FormatCurrencyHelper(toNumberOrNull(this.bid.price), this.bid.price_currency);
        return genericBidPriceFormatter(toNumberOrNull(this.bid.quoted_price), this.bid.quoted_price_currency);
    }
    get quoted_subtotal() {
        if (!this.bid.quoted_price || !this.bid.quoted_price_currency) return null;
        const qty = this.quantity ?? 1;
        const price = toNumberOrNull(this.bid.quoted_price);
        // should we only do this if subtotal is enabled?  or just not call this if not enabled?
        const subtotalAmount = hasValueOrZero(price) ? price * qty : 0;
        return genericBidPriceFormatter(subtotalAmount, this.bid.quoted_price_currency);
    }
    get moq() {
        return this.bid.moq;
    }
    get leadtime() {
        return this.bid.leadtime_iso;
    }
    get deliverydate() {
        return this.bid.deliverydate;
    }
    get country_of_origin() {  // just the code -- get name below
        return this.bid.country_of_origin;
    }
    get country_of_origin_name() {
        return this.bid.country_of_origin_name;
    }
    get shipterms() {
        return this.bid.shipterms;
    }
    get payterms() {
        return this.bid.payterms;
    }
    get comment() {
        return this.bid.comment;
    }
    get nobid() {
        return this.bid.nobid;
    }
    // get isFirstVariant() {  // now setting this in constructor based on the variantIndex
    //     // return true if this line is the first (or only) variant in the parent item
    //     return (this.variant.sort_order === 1);  // NOT RELIABLE -- sort_order is not always set! need to check index instead, or just pass it in
    // }
}

const tableFields = [  // put superset of table fields here
    {
        key: 'item_details',  // will include name, part_number, description
        label: 'Item',
        tdClass: '',
    },
    {
        key: 'variant_description',
        label: 'Variant',
        tdClass: '',
    },
    {
        key: 'quantity_details',
        label: 'Quantity',
        tdClass: '',
    },
    {
        key: 'current_price',
        label: 'Internal Current Price',
        thClass: ['max-width-120', 'text-center'],
    },
    {
        key: 'target_price',
        label: 'Internal Target Price',
        thClass: ['max-width-120', 'text-center'],
    },
]

// now make columns for vendor cols -- get from your canonical definitions, re-arrange into object format that works here
const vendorCols = vendorColsAll.map(vcol => {
    let vcolMaster = vcol.replyViewerGrid || {};  // pull it out first, if its there, then make a copy of it
    let vcolTable = cloneDeep(vcolMaster);  // create a new object, then pull stuff out from big object and put in here
    vcolTable['key'] = vcol.plainKey;  // add in the key
    return vcolTable;
}).filter(vct => !vct.hide);  // filter out any where you set hide: true

const allTableFields = [...tableFields, ...vendorCols]; // combine 'internal' cols and vendor cols

//const tableFieldMap = Object.fromEntries(tableFields.map(tfld => [tfld.key, tfld]));


export default {
    name: 'QuoteSheetReplyData',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        replyId: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            loading: true,  // start true for this
            replyData: {},
            allBidLines: [], // put here after building them all up
            tableFields: [],  // put here after filtering from api data
            visibleQuoteSheetFields: [],  // the keys that are visible -- we might have 'name', or 'part_number', or 'description' turned off
        }
    },
    computed: {

    },
    mounted: function() {
        //this.getData();
        this.getMultipleReplies();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts error message array in this.errorMsgList
        getData: function() {
            this.loading = true;
            return suppliosApi.quoteSheetReply.retrieveInternal(this.replyId)
                .then(response => {
                    this.replyData = response.data;
                    return true;
                })
                .catch(error => {
                    this.apiErrorHandler(error);
                    return false;
                })
                .then(success => {
                    this.loading = false;
                    return success;
                })
        },
        getMultipleReplies: function() {
            this.loading = true;
            let queryParams = new URLSearchParams();  // instantiate it, then use .append(name, value) to add to it
            //let replyIds = ['NCvl70Yeq8E55SsQ1cIgep', 'wZ0RrbXge1RaYxZRaMWkST', 'OZtROIdNUPK5DC7rKHyR1W'];
            let replyIds = [this.replyId];  // ['wZ0RrbXge1RaYxZRaMWkST']  dummy one with data
            replyIds.forEach(rep => {
                queryParams.append('reply', rep);
            });
            let axiosConfig = {
                params: queryParams,  // can be a plain object, or a URLSearchParams object
            };
            return suppliosApi.quoteSheetReply.getMultipleReplies(axiosConfig)
                .then(response => {
                    this.replyData = response.data;  // just for now - change this
                    this.configureTable(response.data.quotesheet);  // do this before setting row data, don't show table until you have rowData
                    this.buildRows(response.data.quotesheet, response.data.replies);
                    return true;
                })
                .catch(error => {
                    this.apiErrorHandler(error);
                    return false;
                })
                .then(success => {
                    this.loading = false;
                    return success;
                });
        },
        configureTable: function(qSheetData) {
            // construct stuff related to the table/grid
            let colsToShow = ['item_details'];
            let itemFieldNames = qSheetData.item_field_names;
            this.visibleQuoteSheetFields = [...itemFieldNames];
            const removeFieldNames = [];
            const quantityFields = ['quantity', 'uom', 'quantity_timeframe'];
            let showQuantity = itemFieldNames.some(ifld => quantityFields.includes(ifld));
            if (showQuantity) {
                colsToShow.push('quantity_details');
            } 
            if (itemFieldNames.includes('current_price')) {
                colsToShow.push('current_price');
            } 
            if (itemFieldNames.includes('target_price')) {
                colsToShow.push('target_price');
            }
            if (itemFieldNames.includes('need_by_date')) {
                colsToShow.push('need_by_date');
            }
            // TODO - add something here about showing variant details
            let hasMultipleVariants = Boolean(qSheetData.quotesheet_items.map(qsi => qsi.variants.length).filter(varCount => (varCount > 1)).length);  // make array of how many variants each item has, filter for any with more than one, are there any?
            if (hasMultipleVariants) {
                colsToShow.push('variant_description');
            }
            let has_multiple_quoted_currency_options = qSheetData.has_multiple_quoted_currency_options ?? false;
            if (!has_multiple_quoted_currency_options) {
                // if not multi-currency, don't show multiple price / subtotal cols
                removeFieldNames.push('quoted_price', 'quoted_subtotal')
            }
            let enabledFieldNames = qSheetData.enabled_field_names.filter(fn => !removeFieldNames.includes(fn));
            let allFieldNames = colsToShow.concat(enabledFieldNames);
            this.tableFields = allTableFields.filter(tfld => allFieldNames.includes(tfld.key));
            console.log(this.tableFields);
        },
        buildVariantLines: function(qs_items) {
            // build a single array of variants, with parent quotesheet_item/linked_product along-side it
            // this un-nests the variants from qs_items
            // don't worry about cloning all qs_items and linked_products as you put them in... since this is not for editing
            let variantLines = [];  // fill this up
            qs_items.forEach(item => {
                let itemKeysToPick = ['id', 'name', 'part_number', 'description', 'sort_order', 'linked_product'];
                let itemOnly = pick(item, itemKeysToPick);
                item.variants.forEach((variant, idx) => {
                    let varLine = {};  // the new object we'll return list of 
                    varLine['variant_id'] = variant.id;  // make it easy to pull this out when we make composite key for bidLines
                    varLine['variant'] = {...variant};
                    varLine['variantIndex'] = idx;  // we use this instead of sort_order, since that is not always set
                    varLine['item'] = itemOnly;
                    variantLines.push(varLine);
                });
            });
            return variantLines;  // use this to further build up lines for each bid
        },
        buildBidLinesForReply: function(variantLines, reply) {
            // run this for EACH reply you're going to show 
            // pass in variantLines (same for every reply) and reply (full object of the reply, once each per reply)
            let replyFieldsToPick = ['id'];  // the fields we want in EACH row in the grid
            let replyData = pick(reply, replyFieldsToPick);
            let variantBidMap = reply.variant_bid_map;  // a mapping object of variant_id: bid object
            let replyBidLines = [];  // all the bid lines for a reply -- generated by looping through variants on quotesheet, looking for matching bid
            variantLines.forEach(varLine => {
                let bidLine = {};  // represents a variant (likely with bid) for a specific reply -- a row in the grid
                // dude, make this a class
                bidLine['id'] = 'var' + varLine.variant_id + '_' + 'rep' + reply.id;  // make a composite id for each line -- variant ID + reply ID -- why?  because if the reply is missing a bid for this variant, we won't have a key to use... this fixes that
                bidLine['reply_id'] = reply.id;
                bidLine['reply'] = replyData;
                bidLine['bid'] = variantBidMap[varLine.variant_id] || {};  // this pulls the bid object out of the map if there, or default to {}
                bidLine['variant'] = varLine.variant;
                bidLine['variantIndex'] = varLine.variantIndex;  // this is the index of the variant in the item
                bidLine['item'] = varLine.item;
                replyBidLines.push(bidLine);
            });
            return replyBidLines;
        },
        buildRows: function(qSheetData, repliesList) {
            // build all the rows of the grid
            // qSheetData is dict of the QuoteSheet from api
            // repliesList is list of reply objects from api
            let variantLines = this.buildVariantLines(qSheetData.quotesheet_items);
            let allBidLines = repliesList.flatMap(reply => this.buildBidLinesForReply(variantLines, reply));
            this.allBidLines = allBidLines.map(bl => new QuoteSheetReplyBidLine(bl));
            console.log(this.allBidLines);
        },
        tbodyTrClass: function(item, type) {
            // item is the row item, 
            // type is 'row' for item row, 'row-details' for item details row, 'row-top' for fixed top row slot, 'row-bottom' for fixed bottom row slot, 'table-busy' for table busy slot
            // should return array, object, or string
            if (type !== 'row') {
                return '';
            }
            return item.isFirstVariant ? 'first-variant' : 'not-first-variant'; // just add this, then style <td> inside via CSS
        }
    }
}
</script>

<style lang="scss">

.quotesheet-reply-data-table {
    border-color: var(--gray-100);
    tr.first-variant {
        td {
            border-top: 1px solid var(--gray-500);
        }
    }
}

</style>